import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  getDeliveryOrder,
  updateDeliveryOrder,
} from "../../../redux/reducer/deliveryOrder/deliveryOrderReducer";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { FormControl, TextField } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminDeliveryOrderDriverSent({
  open,
  handleClose,
  id,
}) {
  // Local State
  const [formData, setFormData] = useState({
    description: "",
  });

  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Pengiriman selesai ?`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Selesai",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        const data = {
          value: {
            status: 3,
            description: formData.description,
          },
          id: id,
          token: token,
        };
        dispatch(updateDeliveryOrder(data)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(
              getDeliveryOrder({
                params: {
                  params: {},
                },
                token: token,
              })
            );
            toast.success(res.payload.message);
            setFormData({
              description: "",
            });
            handleClose();
          } else {
            toast.error(res.payload.message);
          }
        });
      } else {
        setFormData({
          description: "",
        });
      }
    });
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{"Keterangan Pengiriman"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent style={{ padding: "5px 24px" }}>
          <FormControl>
            <TextField
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
              inputProps={{ maxLength: 100 }}
              size="small"
              error={false}
              label="Keterangan"
              value={formData.description}
              name="description"
              fullWidth
              variant="standard"
              style={{ width: "90vw", maxWidth: "400px" }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button type="submit">Submit</Button>
          <Button onClick={() => handleClose()} color="error">
            Cancel
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

AdminDeliveryOrderDriverSent.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  id: PropTypes.string,
};
